import React from 'react'
import {Route, Routes} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {CompanyDetailsPage} from './views/CompanyDetailsPage'
import {CompanyPageBreadcrumbs} from './core/_constants'

export const CompanyPageRoutes = () => {
  const {formatMessage} = useIntl()
  const {CompanyPageBreadCrumbs} = CompanyPageBreadcrumbs()

  return (
    <div className='mt-3'>
      <Routes>
        <Route
          index
          element={
            <>
              <PageTitle
                breadcrumbs={CompanyPageBreadCrumbs}
                description={formatMessage({id: 'Company Page'})}
              >
                {formatMessage({id: 'Company Page'})}
              </PageTitle>
              <CompanyDetailsPage />
            </>
          }
        />
      </Routes>
    </div>
  )
}
